var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCampaignsViewAddContactsPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.625 9.625H11.375V4.375C11.375 4.14294 11.2828 3.92038 11.1187 3.75628C10.9546 3.59219 10.7321 3.5 10.5 3.5C10.2679 3.5 10.0454 3.59219 9.88128 3.75628C9.71719 3.92038 9.625 4.14294 9.625 4.375V9.625H4.375C4.14294 9.625 3.92038 9.71719 3.75628 9.88128C3.59219 10.0454 3.5 10.2679 3.5 10.5C3.5 10.7321 3.59219 10.9546 3.75628 11.1187C3.92038 11.2828 4.14294 11.375 4.375 11.375H9.625V16.625C9.625 16.8571 9.71719 17.0796 9.88128 17.2437C10.0454 17.4078 10.2679 17.5 10.5 17.5C10.7321 17.5 10.9546 17.4078 11.1187 17.2437C11.2828 17.0796 11.375 16.8571 11.375 16.625V11.375H16.625C16.8571 11.375 17.0796 11.2828 17.2437 11.1187C17.4078 10.9546 17.5 10.7321 17.5 10.5C17.5 10.2679 17.4078 10.0454 17.2437 9.88128C17.0796 9.71719 16.8571 9.625 16.625 9.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignsViewAddContactsPlus);
export default __webpack_public_path__ + "static/media/campaigns-view-add-contacts-plus.7401dc63f0ae6f3b0fc1a53a3b69928c.svg";
export { ForwardRef as ReactComponent };